import { apiGet } from './client';
import type { UserProfile } from './types';

export function getCurrentUser(): Promise<UserProfile> {
  return apiGet<UserProfile>('/api/v1/users/me');
}
